<template>
  <a class="side-nav-button" href="#" :class="{active : isActive}" :scrollTo="scrollTo" v-on:mouseover="showTitle" v-on:mouseleave="hideTitle">
    <span></span>
  </a>
</template>

<script>
      import 'TweenMax'
      import {bus} from './../consts'

      export default {
        name: 'SideNavButton',
        props: [
          'isActive',
          'scrollTo'
        ],
        data() {
          return {
              links: null
          }
        },
        methods: {
          showTitle() {
            bus.$emit('showSideNavTitle', this.scrollTo)
          },
          hideTitle() {
            bus.$emit('hideSideNavTitle')
          }
        }
      }
</script>

<style lang="scss">
  @import '../scss/the-goods';

  .side-nav {
    a.side-nav-button {
      position        : relative;
      width           : 25px;
      height          : 25px;
      display         : flex;
      justify-content : center;
      align-items     : center;
      border-radius   : 50%;
      margin          : 5px;

      .landscape-mode & {
        width  : 20px;
        height : 20px;
      }

      span {
        width         : 5px;
        height        : 5px;
        background    : black;
        display       : block;
        border-radius : 50%;
      }

      &:after {
        content       : '';
        display       : block;
        width         : 100%;
        height        : 100%;
        position      : absolute;
        border        : 2px solid black;
        border-radius : 50%;
        transform     : scale(0);
        transition    : transform .3s;
        top           : 0px;
        left          : 0px;
      }

      &.active {
        &:after {
          transform : scale(1);
        }

        &:hover {
          &:after {
            transform : scale(1);
          }
        }
      }

      &:hover {
        &:after {
          transform : scale(.8);
        }
      }

      &:first-of-type {
        margin-top: 10px;
      }

      &:last-of-type {
        margin-bottom: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SideNavButton.vue